import produce from "immer";
import { CustomerVendorAttachmentActions } from ".";
import { LoadState } from "../../constants/enums";
import { IStoreState } from "../initialStoreState";
import {
	CLEAR_COMPANY_OUTLET_ATTACHMENT,
	CLEAR_COMPANY_OUTLET_ATTACHMENT_STATE,
	FETCH_COMPANY_OUTLET_ATTACHMENT_LIST_FAILED,
	FETCH_COMPANY_OUTLET_ATTACHMENT_LIST_PROGRESS,
	FETCH_COMPANY_OUTLET_ATTACHMENT_LIST_SUCCESS,
} from "./companyOutletAttachmentActions";
import {
	defaultCompanyOutletAttachment,
	defaultCompanyOutletAttachmentState,
} from "./defaultState";

export const companyOutletAttachmentReducer = (
	state: IStoreState["companyOutletAttachment"] = defaultCompanyOutletAttachmentState,
	action: any
) => {
	switch (action.type) {
		case FETCH_COMPANY_OUTLET_ATTACHMENT_LIST_PROGRESS: {
			const newState = produce(state, (draftState) => {
				draftState.list.loading = LoadState.InProgress;
			});
			return newState;
		}
		case FETCH_COMPANY_OUTLET_ATTACHMENT_LIST_SUCCESS: {
			const { data, totalRecords } = action.payload;
			const newState = produce(state, (draftState) => {
				draftState.list.loading = LoadState.Loaded;
				draftState.list.data = data;
				draftState.list.totalRecords = totalRecords;
			});
			return newState;
		}
		case FETCH_COMPANY_OUTLET_ATTACHMENT_LIST_FAILED: {
			const newState = produce(state, (draftState) => {
				draftState.list.loading = LoadState.InProgress;
			});
			return newState;
		}

		case CLEAR_COMPANY_OUTLET_ATTACHMENT: {
			const newState = produce(state, (draftState) => {
				draftState.attachemnt.loading = LoadState.NotLoaded;
				draftState.attachemnt.data = defaultCompanyOutletAttachment;
			});
			return newState;
		}
		case CLEAR_COMPANY_OUTLET_ATTACHMENT_STATE: {
			return defaultCompanyOutletAttachmentState;
		}
		default: {
			return state;
		}
	}
};
